import React, {Component} from 'react';

import {
  clearChunkReloadFlag,
  reloadOnChunkError,
} from '../../../libs/reloadOnChunkError';

export default (importComponent) => {
  class AsyncComponent extends Component {
    state = {
      Component: null,
      loadFailed: false,
    };

    async componentDidMount() {
      try {
        const {default: Component} = await importComponent();

        this.setState({
          Component: Component,
          loadFailed: false,
        });
        clearChunkReloadFlag();
      } catch (error) {
        // Swallow after recovery attempts so React does not log an uncaught
        // promise rejection for a known post-deploy chunk miss.
        if (reloadOnChunkError(error)) {
          return;
        }

        console.error(error);
        this.setState({loadFailed: true});
      }
    }

    render() {
      const {Component, loadFailed} = this.state;

      if (loadFailed) {
        return null;
      }

      return !!Component ? <Component {...this.props} /> : null;
    }
  }

  return AsyncComponent;
};
